const TABS = [
  { key: "", label: "ALL" },
  { key: "mlb", label: "MLB" },
  { key: "nba", label: "NBA" },
  { key: "nhl", label: "NHL" },
  { key: "nfl", label: "NFL" },
  { key: "mma", label: "MMA" },
];

export default function SportTabs({ value, onChange, testidPrefix = "sport" }) {
  return (
    <div className="flex border-b border-zinc-800" data-testid={`${testidPrefix}-tabs`}>
      {TABS.map((t) => (
        <button
          key={t.key || "all"}
          onClick={() => onChange(t.key)}
          data-testid={`${testidPrefix}-tab-${t.key || "all"}`}
          className={`px-3.5 py-2 mono text-[10px] tracking-wider border-r border-zinc-800 ${
            value === t.key
              ? "bg-zinc-900/60 text-[#00D4FF] border-b border-b-[#00D4FF]"
              : "text-zinc-400 hover:text-zinc-200"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
